import { configureStore } from "@reduxjs/toolkit";
import liveTracking from "./actions/liveTracking";

export const store = configureStore({
  reducer: {
    liveTracking: liveTracking,
  },
});
